import { createAction, handleActions } from "redux-actions";

import config from "appConfig";
import {
  api,
  checkEmptyObject
} from "../../../services";

import {
  cartInterface,
  rootReducerInterface,
} from "../../../typings/interfaces";

import { AdsSortOption, ShoppingCart, ShoppingCartList, ShoppingCartListParsed, ShoppingCartParsed } from "../../../models";


const parseShoppingCartData = (cart: ShoppingCart[]): ShoppingCartParsed[] => {
  return cart.map((cart) => {
    return {
      id: cart.id,
      createdAt: cart.createdAt,
      name: cart.item.name,
      email: cart.email,
      paymentMethod: cart.paymentMethod,
      status: cart.status,
      userId: cart.userId,
      userName: cart.userName,
      referenceNumber: cart.referenceNumber,
      invoiceId: cart.invoiceId,
      priceWithoutVat: cart.item.priceWithoutVat,
      vat: cart.item.vat,
      price: cart.item.price,
      type: cart.item.type,
    }
  });
}

const CART_LIST = "CART_LIST";
const CART_GET = "CART_GET";
const CART_UPDATE = "CART_UPDATE";

// ACTIONS

// Get cart
export const getCart = createAction(
  CART_GET,
  async (
    cartId: string,
    callback?: (cart: ShoppingCartParsed | Boolean) => void
  ) => {
    let cart: ShoppingCart;

    try {
      cart = await api.Cart.single(cartId);

      if (!checkEmptyObject(cart)) {
        callback && callback(false);
        return null;
      }

      const parsedCartData = parseShoppingCartData([cart]);
      callback && callback(parsedCartData[0]);
      return cart[0];
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

// Get carts
export const getCarts = createAction(
  CART_LIST,
  async (
    queryParams: any = {},
    callback?: (cart: ShoppingCartListParsed | Boolean) => void
  ) => {
    const searchParams = {
      ...queryParams,
      sortOption: AdsSortOption.DateDesc,
      itemPerPage: queryParams.itemPerPage || config.maxAdPerPage,
    }

    let carts: ShoppingCartList;

    try {
      carts = await api.Cart.list(searchParams);

      if (!checkEmptyObject(carts)) {
        callback && callback(false);
        return null;
      }

      const data = {
        data: parseShoppingCartData(carts.data),
        count: carts.count,
        page: carts.currentPage,
        nextPage: carts.nextPage,
        previousPage: carts.previousPage,
        totalPrice: carts.totalPrice,
      }

      callback && callback(data);
      return data;
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

// Update cart
export const updateCart = createAction(
  CART_UPDATE,
  async (
    cartId: string,
    data: any,
    callback?: (cart: ShoppingCartParsed | Boolean) => void
  ) => {
    let cart: ShoppingCart;

    try {
      cart = await api.Cart.update(cartId, data);

      if (!checkEmptyObject(cart)) {
        callback && callback(false);
        return null;
      }

      const parsedCartData = parseShoppingCartData([cart]);
      callback && callback(parsedCartData[0]);
      return cart[0];
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

export const selectCarts = (state: rootReducerInterface) =>
  state.admin.cart.carts;

// INITIAL STATE
const initialState: cartInterface = {
  cart: null,
  carts: null,
};


// REDUCERS
const cartReducers = {
  getCart: (state: cartInterface, { payload }) => ({
    ...state,
    cart: !payload ? {} : { ...payload }
  }),
  getCarts: (state: cartInterface, { payload }) => ({
    ...state,
    carts: !payload ? {} : payload
  }),
  createCart: (state: cartInterface, { payload }) => ({
    ...state,
    cart: !payload ? {} : { ...payload }
  }),
  updateCart: (state: cartInterface, { payload }) => ({
    ...state,
    cart: !payload ? {} : { ...payload }
  })
};

export default handleActions(
  {
    [CART_GET]: cartReducers.getCart,
    [CART_LIST]: cartReducers.getCarts,
    [CART_UPDATE]: cartReducers.updateCart,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageCartPage/cart.ducks.ts